import * as fetchingApi from '@services/fetchingApi'
import { webApiBuildUrl } from '@api/utils'

// Authorize
export const checkAuthorization = () => fetchingApi.Get(webApiBuildUrl('api/customer/check-authorization'))
export const checkToken = (ctx) => fetchingApi.Get(webApiBuildUrl('api/customer/check-token'), ctx)
export const confirmCustomer = (confirmData, ctx) =>
    fetchingApi.Post(webApiBuildUrl('api/customer/confirm'), confirmData, ctx)
// eslint-disable-next-line max-len
export const profileConfirmChangePhone = async (phone) =>
    fetchingApi.Post(webApiBuildUrl('api/Customer/profile/confirm-change-phone'), {
        phone
    })
export const profileChangePhone = async (phone, code) =>
    fetchingApi.Post(webApiBuildUrl('api/customer/profile/change-phone'), {
        phone,
        code
    })

// eslint-disable-next-line max-len
export const createCustomer = (createCustomerData, ctx) =>
    fetchingApi.Post(webApiBuildUrl('api/customer/create-customer'), createCustomerData, ctx)

// Profile
// eslint-disable-next-line max-len
export const getCustomerProfile = (ctx, isThrowError = true) =>
    fetchingApi.Get(webApiBuildUrl('api/customer/profile'), ctx, isThrowError)
export const getCustomerOrders = async (ctx) => fetchingApi.Get(webApiBuildUrl('api/customer/orders'), ctx)
export const postCustomerProfile = async (profile) =>
    fetchingApi.Post(webApiBuildUrl('api/customer/profile/edit'), profile)

export const logout = async () => fetchingApi.Post(webApiBuildUrl('api/customer/logout'))

// eslint-disable-next-line max-len
export const orderDetails = async (ctx, orderId, shipment) =>
    fetchingApi.Post(webApiBuildUrl(`api/customer/order/${orderId}/details`), shipment, ctx)

// Favorites
export const mergeFavorits = async (goodIds, isThrowError = true) =>
    fetchingApi.Post(webApiBuildUrl('api/customer/favorits/merge'), goodIds || [], null, isThrowError)
// eslint-disable-next-line max-len
export const saveFavorite = async (goodId) => fetchingApi.Post(webApiBuildUrl('api/customer/favorite'), goodId)
export const deleteFavorite = async (goodId) => fetchingApi.Post(webApiBuildUrl('api/customer/favorite/delete'), goodId)
